import React, { useState } from "react"
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import './Assets/App.css'
import './Assets/admin.css'
import "react-datepicker/dist/react-datepicker.css"
import Auth from './Utilities/Auth'
import NavBar from "./Components/NavBar"
import Login from './Pages/Login'
import Admin from "./Pages/Admin"
import MacroEco from "./Pages/MacroEco"
import Publication from "./Pages/Publication"
import NotFound from "./Pages/NotFound"
import PlayerForm from './VideoPlayer/PlayerForm'
import { Dashboard } from "./Pages/Dashboard"
import { sections } from './Utilities/loadData'
import * as ajax from './Utilities/ajax'

const canViewReport = JSON.parse(sessionStorage.getItem('canViewReport'))
const canViewVideo = JSON.parse(sessionStorage.getItem('canViewVideo'))
const canViewMacroEco = JSON.parse(sessionStorage.getItem('canViewMacroEco'))

export default function App() {
  const [section, setSection] = useState(undefined)
  const [_sections, set_Section] = useState([])
  const [userRole, setUserRole] = useState(undefined)
  const [backgroundImage, setBackgroundImage] = useState("");

  React.useEffect(() => {
    // Fetch roles
    ajax.get(`/user/self`)
      .then(x => setUserRole(((x || {}).data || {}).role || 'customer'))
      .catch(e => setUserRole('customer'))

    // Fetch and keep video sections
    sections().then(x => set_Section(x))
  }, [])

  React.useEffect(() => {
    const checkPathname = () => {
      const bgImage = ["/", "/dashboard"].includes(window.location.pathname)
        ? "url('/bg-login2.png')"
        : "url('/bg-content.png')";
      setBackgroundImage(bgImage);
    };

    checkPathname(); // Initial check
    const interval = setInterval(checkPathname, 1);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const RedirectPage = () => {
    if (_isAdmin) {
      return <Redirect to="/admin" />
    }
    else if (canViewMacroEco || canViewReport || canViewVideo) {
      return <Redirect to="/dashboard" />
    }
    else {
      return <Redirect to="/home" />
    }
  }

  const ProtectedRoute = ({ component: Component, ...rest }) => {
    if (
      (canViewMacroEco && rest.path === "/macroeco")
      || (canViewReport && rest.path === "/publication")
      || (canViewVideo && rest.path === "/video")
      || (_isAdmin && rest.path === "/admin")
      || (_isAdmin && rest.path === "/dashboard")
      || (_isAdmin && rest.path === "/macroeco")
      || (_isAdmin && rest.path === "/publication")
      || (_isAdmin && rest.path === "/video")
      || (rest.path === "/dashboard")
    )
      return (
        <Route {...rest} render={
          props => <Component {...rest} {...props} />
        } />
      )
    else return <Redirect to="/" />
  }

  const _isAdmin = userRole === 'admin'

  return (
    <div style={{
      minHeight: "100%",
      backgroundImage: backgroundImage,
      backgroundSize: "cover"
    }}>
      <Router>
        <React.Fragment>
          <NavBar
            setSection={setSection}
            sections={_sections}
            isAdmin={_isAdmin}
          />
          <Switch>
            {!Auth.isUserAuthenticated() && (
              <Login />
            )}
            {_isAdmin && (
              <Route
                path="/home"
                exact
                render={() => <Redirect to="/admin" />}
              />
            )}
            {!_isAdmin && (
              <Route
                path="/home"
                exact
                render={() => <Redirect to="/dashboard" />}
              />
            )}
            <Route
              path='/home'
              exact
              component={NotFound}
            />
            <ProtectedRoute
              path='/dashboard'
              exact
              component={Dashboard}
              canViewMacroEco={canViewMacroEco}
              canViewReport={canViewReport}
              canViewVideo={canViewVideo}
              isAdmin={_isAdmin}
            />
            <ProtectedRoute
              path="/macroeco"
              exact
              component={MacroEco}
              section={section}
            />
            <ProtectedRoute
              path="/publication"
              exact
              component={Publication}
              section={section}
            />
            <ProtectedRoute
              path='/video'
              component={PlayerForm}
              section={section}
              setSection={setSection}
            />
            <ProtectedRoute
              path='/admin'
              exact
              component={Admin}
            />
            <Route
              path="/logout"
              component={Logout}
            />
            <Route
              path="/"
              render={() => RedirectPage()}
            />
          </Switch>
        </React.Fragment>
      </Router>
    </div>
  );
}

const Logout = () => {
  Auth.deauthenticateUser()
  window.location.pathname = '/'
}
